import { forwardRef, type TextareaHTMLAttributes } from 'react';

import { cn } from '@eliadmin/core/src/utils/style-utils';

/**
 * Figma „Textarea · Správa“ field (232:14151): 96 px box, radius 12, 1 px #E2E5DF border, padding
 * 14 / 16, Body/M value with the #5D655D placeholder. It grows with the text where the browser
 * supports `field-sizing` (up to 320 px, then it scrolls). Focus = green border + `shadow-focus`
 * like the form kit's `TextInput`; an invalid box stays red. Forwards the ref for `register()`.
 */
export const MessageTextarea = forwardRef<
  HTMLTextAreaElement,
  TextareaHTMLAttributes<HTMLTextAreaElement> & { invalid?: boolean }
>(function MessageTextarea({ invalid, className, ...props }, ref) {
  return (
    <textarea
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        'nt-body-m block max-h-80 min-h-24 w-full resize-none rounded-xl border bg-white px-4 py-3.5 text-[#0D110D] outline-none transition-colors [field-sizing:content] placeholder:text-[#5D655D] focus:shadow-focus',
        invalid ? 'border-[#D92D20]' : 'border-[#E2E5DF] focus:border-[#127A26]',
        className,
      )}
      {...props}
    />
  );
});
